import { render, staticRenderFns } from "./CardsList.html?vue&type=template&id=7b0c5026&scoped=true&external"
import script from "./CardsList.js?vue&type=script&lang=js&external"
export * from "./CardsList.js?vue&type=script&lang=js&external"
import style0 from "./CardsList.vue?vue&type=style&index=0&id=7b0c5026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0c5026",
  null
  
)

export default component.exports